import { makeStyles } from '@material-ui/core'

export const useDeskStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    paddingBottom: theme.spacing(5)
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'flex-start',
    '&$titleWithRight': {
      justifyContent: 'space-between'
    }
  },
  typography: {
    fontWeight: theme.typography.fontWeightBold
  },
  titleWithRight: {}
}))

export const useMobStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    paddingBottom: theme.spacing(6)
  },
  btnBack: {
    width: '30%',
    padding: 0,
    marginLeft: -12
  }
}))
